import NavLinkAdapter from '@fuse/core/NavLinkAdapter';
import Collapse from '@mui/material/Collapse';
import Icon from '@mui/material/Icon';
import IconButton from '@mui/material/IconButton';
import ListItemText from '@mui/material/ListItemText';
import makeStyles from '@mui/styles/makeStyles';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { withRouter } from 'react-router-dom';
import ListItemButton from '@mui/material/ListItemButton';
import FuseNavBadge from '../FuseNavBadge';
import FuseNavItem from '../FuseNavItem';

const useStyles = makeStyles((theme) => ({
	root: {
		padding: 0,
		'&.open': {
			backgroundColor: theme.palette.mode === 'dark' ? 'rgba(255,255,255,.015)' : 'rgba(0,0,0,.04)',
		},
	},
	item: (props) => ({
		height: 40,
		width: 'calc(100% - 16px)',
		borderRadius: '0 20px 20px 0',
		paddingRight: 8,
		paddingLeft: props.itemPadding > 80 ? 80 : props.itemPadding,
		// color: theme.palette.text.primary,
		'&.active > .nav-list-item-text > span': {
			fontWeight: 600,
		},
		'& .nav-list-item-icon': {
			marginRight: 16,
		},
	}),
}));

function needsToBeOpened(location, item) {
	return location && isUrlInChildren(item, location.pathname);
}

function isUrlInChildren(parent, url) {
	if (!parent.children) {
		return false;
	}

	for (let i = 0; i < parent.children.length; i += 1) {
		if (parent.children[i].children) {
			if (isUrlInChildren(parent.children[i], url)) {
				return true;
			}
		}

		if (parent.children[i].url === url || url.includes(parent.children[i].url)) {
			return true;
		}
	}

	return false;
}

const FuseNavVerticalCollapse = (props) => {
	// const userRole = useSelector(({ auth }) => auth.user.role);
	const [open, setOpen] = useState(() => needsToBeOpened(props.location, props.item));
	const { item, nestedLevel } = props;
	const classes = useStyles({
		itemPadding: nestedLevel > 0 ? 40 + nestedLevel * 16 : 24,
	});
	const { t } = useTranslation();

	useEffect(() => {
		if (needsToBeOpened(props.location, props.item)) {
			if (!open) {
				setOpen(true);
			}
		}
		// eslint-disable-next-line
	}, [props.location, props.item]);

	function handleClick() {
		setOpen(!open);
	}

	// const hasPermission = useMemo(() => FuseUtils.hasPermission(item.auth, userRole), [item.auth, userRole]);

	// if (!hasPermission) {
	// 	return null;
	// }

	const IconComponent = item.Icon;

	return (
		<ul className={clsx(classes.root, open && 'open')}>
			<ListItemButton
				className={clsx(classes.item, 'nav-list-item mt-12 starter:text-white')}
				onClick={handleClick}
				component={item.url ? NavLinkAdapter : 'li'}
				to={item.url}
				role="button"
			>
				<IconComponent className="nav-list-item-icon text-16 flex-shrink-0 scale-150" />

				<ListItemText
					className="nav-list-item-text ml-20"
					primary={item.translate ? t(item.translate) : item.title}
					classes={{ primary: 'text-14 font-semibold' }}
				/>

				{item.badge && <FuseNavBadge className="mx-4" badge={item.badge} />}

				<IconButton
					disableRipple
					className="w-40 h-40 -mx-12 p-0 focus:bg-transparent hover:bg-transparent"
					onClick={(ev) => ev.preventDefault()}
					style={{ position: 'absolute', right: 0 }}
					size="large"
				>
					<Icon className="text-24 arrow-icon starter:text-white" color="default">
						{open ? 'expand_less' : 'expand_more'}
					</Icon>
				</IconButton>
			</ListItemButton>
			{item.children && (
				<Collapse in={open} className="collapse-children">
					{item.children.map((_item) => (
						<FuseNavItem
							key={_item.id}
							type={`vertical-${_item.type}`}
							item={_item}
							nestedLevel={nestedLevel + 1}
						/>
					))}
				</Collapse>
			)}
		</ul>
	);
};

FuseNavVerticalCollapse.propTypes = {
	item: PropTypes.shape({
		id: PropTypes.string.isRequired,
		title: PropTypes.string,
		icon: PropTypes.string,
		children: PropTypes.array,
	}),
};
const NavVerticalCollapse = withRouter(React.memo(FuseNavVerticalCollapse));

export default NavVerticalCollapse;
